import './style.modules.scss'

import { Link, LinkProps, LinkVariant } from '@ampcore/adel-react'
import { AnalyticsTagBuilder } from '@dai-team/analytics-library'
import React, { useEffect, useMemo } from 'react'

export type StickyMobileCtaProps = {
  link: LinkProps
  testId?: string
}

export const StickyMobileCta = (props: StickyMobileCtaProps) => {
  const { link, testId } = props
  const atb = useMemo(
    () =>
      new AnalyticsTagBuilder()
        .setDefaultName('StickyMobileCta')
        .setAnalyticsName(link.analyticsName),
    [link.analyticsName]
  )
  useEffect(() => {
    document.body.classList.add('is-stickyCta')
    return () => {
      document.body.classList.remove('is-stickyCta')
    }
  }, [])
  return (
    <div className="StickyMobileCta">
      <Link
        variant={LinkVariant.SECONDARY}
        className="StickyMobileCta-button Button--block u-paddingVert16"
        url={link.url}
        target={link.target}
        ariaLabel={link.ariaLabel}
        data-testid={testId ? `${testId}-button` : null}
        name={link.name}
        {...atb.dataAnalyticAttribute(link.analyticsName, 'cta-click')}
      />
    </div>
  )
}
